import { useEffect, useState } from 'react'
import { Card, Col, Row, Stack } from 'react-bootstrap'
import DataGrid from '../../../components/common/dataGrid/DataGrid';
import ActionCell from '../../../components/common/dataGrid/ActionCell';
import { Link, useNavigate } from 'react-router-dom';
import { faqDelete, getList } from '../../../services/faqService';
import Loader from '../../../components/common/Loader';
import constantValues from '../../../constants/constantValues';
import { truncateText } from '../../../helpers/helpersMethods';
import DeleteModal from '../../../components/common/DeleteModal';
import { toast } from 'react-toastify';
import { nameBasedProtectedRoutes } from '../../../router/protected';
import { getEmailTemplateList } from '../../../services/templateService';


const viewData = [
  { id: 'active', name: 'Enable' },
  { id: 'inactive', name: 'Disable' }
];

export const AllTemplate = () => {
  const [filterData, setFilterData] = useState({ search: '',searchByCreatedDate:'',sortByStatus:'' });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(constantValues.rowPerPage);
  const [totalPages, setTotalPages] = useState(0);
  const [totalReults, setTotalResults] = useState(0);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("asc");
  const [deletestatus, setDeletestatus] = useState(false);
  const [deleteRecordId, setDeleteRecordId] = useState();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const searchData:string = filterData ? filterData.search:'';
    const sortByStatus:any = filterData ? filterData.sortByStatus:'';
    setLoading(false);
    templateList({ page: currentPage, limit: rowPerPage,sortColumn:sortColumn,sortDirection:sortDirection,search:searchData,searchByStatus:sortByStatus });
  }, [currentPage]);

  useEffect(() => {
    const searchData:string = filterData ? filterData.search:'';
    const sortByStatus:any = filterData ? filterData.sortByStatus:'';
    setCurrentPage(1);
    setLoading(false);
    templateList({ page: currentPage, limit: rowPerPage,sortColumn:sortColumn,sortDirection:sortDirection,search:searchData,searchByStatus:sortByStatus });
  }, [sortColumn,sortDirection]);
  
  useEffect(() => {
    const searchData:string = filterData ? filterData.search:'';
    const sortByStatus:any = filterData ? filterData.sortByStatus:'';
    if(searchData.length > 1  || sortByStatus.length > 1)
    {
      setCurrentPage(1);
      setLoading(false);
      templateList({ page: currentPage, limit: rowPerPage,sortColumn:sortColumn,sortDirection:sortDirection,search:searchData,searchByStatus:sortByStatus});
    }else
    {
      setCurrentPage(1);
      setLoading(false);
      templateList({ page: currentPage, limit: rowPerPage,sortColumn:sortColumn,sortDirection:sortDirection});
    }
  }, [filterData]);
  const handleDeleteClick = (id:any) =>
  {
    if(id)
    {
      setDeleteRecordId(id);
    }
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  
  /**
   * Description fetch user list
   * @date 19/04/2023 - 12:10:33
   *
   * @async
   * @param {*} params
   * @returns {*}
   */
  const templateList = async (params:any) => {
    setLoading(true);
    getEmailTemplateList({ ...params, search: params.search?.trim() }).then(
      (response) => {
        setLoading(false);
        setData(response.data?.record);
        setTotalPages(response.data?.totalPages);
        setTotalResults(response.data?.totalResults);
        
      }
    );
  };
  const columns = [
    {
      id:'id',
      name: '#',
      sortable: true,
      center: true,
      selector: (row:any, index:any) => (currentPage - 1) * rowPerPage + index + 1,
      width: '60px',
    },
    {
        id:'title',
        selector: (row: any) => row.title,
        name: 'Title',
        sortable: true,
        minWidth: '200px',
        cell: (row: any) => {return truncateText(row.title)}
    },
    {
        id:'subject',
        selector: (row: any) => row.subject,
        name: 'Subject',
        sortable: true,
        minWidth: '200px',
        cell: (row: any) => {return row.subject}
    },
    {
      id:'action',
      selector: (row: any) => row.action,
      name: 'Action',
      width: '100px',
      center: true,
      button: true,
      cell: (row: any) =>
      {
        return (<ActionCell controlId="email-template" isViewEnable={true}
         isEditEnable={true} 
          redirectID={row.id}
           handleDeleteClick={()=>handleDeleteClick(row.id)}/>);
      } 
    },
  
  ];
  return (
    <>
    <div className="d-flex flex-column h-100 pageContainer px-sm-1 w-100 pb-sm-1">
      <div className="pageHeader px-3 my-1 pt-1 user-select-none">
        <Row className="align-items-center min-h-51">
          <Col>
            <h1 className="fw-semibold h4 my-2">Email Template</h1>
          </Col>
          
        </Row>
      </div>
      <div className="flex-grow-1 overflow-auto pageContent px-3 pb-3">
        <Card className="h-100 p-3 w-100 border-light-subtle pageContentInner">
          <div className="d-flex flex-column h-100 rounded-0 dataGridListMain">
          <DataGrid
              columns={columns}
              data={data}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              pagination={true}
              totalPages={totalPages}
              totalRecords={totalReults}
              rowPerPage={rowPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              sortColumn={sortColumn}
              setSortColumn = {setSortColumn}
              sortDirection={sortDirection}
              setSortDirection = {setSortDirection}
              hideRightFilters={true}
            />
          </div>
        </Card>
      </div>
    </div>
    <Loader isLoading={loading} />
   
    </>
  )
}
